import api from "./apis/api";
import { logger } from "../utils/utils";

class FermentationService {
  createFermentationApi(fermentationReq) {
    logger("FermentationService", "createFermentationApi");
    return api.fermentation.createFermentationApi(fermentationReq);
  }

  getFermentationApi(fermentationReq) {
    logger("FermentationService", "getFermentationApi");
    return api.fermentation.getFermentationApi(fermentationReq);
  }

  getFermentationDetailsById(fermentationId) {
    logger("FermentationService", "getFermentationDetailsById");
    return api.fermentation.getFermentationDetailsById(fermentationId);
  }

  updateFermentationApi(fermentationReq) {
    logger("FermentationService", "updateFermentationApi");
    return api.fermentation.updateFermentationApi(
      fermentationReq?.fermentationId,
      fermentationReq?.payload,
    );
  }

  createChemistryLogs(chemistryLogsReq) {
    logger("FermentationService", "createChemistryLogs");
    return api.fermentation.createChemistryLogs(chemistryLogsReq);
  }

  getChemistryLogsList(chemistryLogsReq) {
    logger("FermentationService", "getChemistryLogsList");
    return api.fermentation.getChemistryLogsList(chemistryLogsReq);
  }

  updateChemistryLogs(chemistryLogsReq) {
    logger("FermentationService", "updateFarmInspection");
    return api.fermentation.updateChemistryLogs(
      chemistryLogsReq?.chemistryLogsId,
      chemistryLogsReq?.payload,
    );
  }

  deleteChemistryLogs(chemistryLogsId) {
    logger("FermentationService", "deleteChemistryLogs");
    return api.fermentation.deleteChemistryLogs(chemistryLogsId);
  }

  getTankList(tankLogsReq) {
    logger("FermentationService", "getTankList");
    return api.fermentation.getTankList(tankLogsReq);
  }

  getTankDetailsById(itemId) {
    logger("FermentationService", "getTankDetailsById");
    return api.fermentation.getTankDetailsById(itemId);
  }
}

export default new FermentationService();
